import './ServicesSection.css';
import floorPlansImage from '../img/2d_floor_plan.avif';
import modelingImage from '../img/3d_render_design.avif';
import renderingImage from '../img/3d_visualization.avif';
import bimImage from '../img/housekaar_BIM.avif';
import virtualToursImage from '../img/virtual_tours_housekaar.avif';
import interiorDesignImage from '../img/3D_interior_design.avif';
import { Link } from 'react-router-dom'; // Import Link

const ServicesSection = () => {
  const designData = [
    {
      image: floorPlansImage,
      title: '2D Floor Plans',
      description: 'Detailed architectural drawings for accurate construction and planning, meticulously crafted to include comprehensive floor plans, elevations, and site plans for precise execution.',
      link: '/two-d-plans', // Updated link
      linkText: 'View 2D Plans',
    },
    {
      image: modelingImage,
      title: '3D Architectural Modeling',
      description: 'Realistic 3D models for visualizing building designs, interiors, and exteriors. Enhance client presentations and project understanding significantly and effectively.',
      link: '/three-d-architectural-modeling', // Updated link
      linkText: 'Explore 3D Models',
    },
    {
      image: renderingImage,
      title: '3D Rendering & Visualization',
      description: 'High-quality rendered images and animations for showcasing detailed architectural and interior designs. Provides a photorealistic view of the project.',
      link: '/three-d-rendering-visualization', // Updated link
      linkText: 'View Renderings',
    },
    {
      image: bimImage,
      title: 'Building Information Modeling (BIM)',
      description: 'Integrated BIM services for efficient project planning, coordination, and management. Includes 3D modeling, clash detection, and data integration.',
      link: '/building-information-modeling', // Updated link
      linkText: 'Learn About BIM',
    },
    {
      image: virtualToursImage,
      title: 'Virtual Tours & Walkthroughs',
      description: 'Interactive virtual tours for immersive project experiences. Allows clients to explore designs in a realistic environment.',
      link: '/virtual-tours-walkthroughs', // Updated link
      linkText: 'Explore Virtual Tours',
    },
    {
      image: interiorDesignImage,
      title: '3D Interior Design',
      description: 'Detailed 3D models of interior spaces, including furniture, lighting, and finishes. Visualize and refine interior designs before construction.',
      link: '/three-d-interior-design', // Updated link
      linkText: 'View Interior Designs',
    },
  ];

  return (
    <div>
      <div className="construction-design">
        <h2>Cutting-Edge Construction Visualization</h2>
        <p>Visualize your construction projects with our comprehensive 2D and 3D design services. We bring your ideas to life with detailed plans and immersive visualizations.</p>
        <div className="design-content">
          {designData.map((item, index) => (
            <div className="design-item" key={index}>
              <img src={item.image} alt={item.title} className="design-image" loading="lazy"/>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link to={item.link}>{item.linkText}</Link> {/* Use Link */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;